import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

// Firebase configuration for voice-coach project
const firebaseConfig = {
  apiKey: "AIzaSyBic4TktML1fPCIgV7WMnqPSU_Ru1cmMz4",
  authDomain: "voice-coach-468903.firebaseapp.com",
  projectId: "voice-coach-468903",
  storageBucket: "voice-coach-468903.firebasestorage.app",
  messagingSenderId: "406125116283",
  appId: "1:406125116283:web:c532e12973a6c6645c9bde"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Configure Google Provider
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;